import { Button, Checkbox, Col, DatePicker, Form, Row } from "antd"
import styles from "../../Notice/Step/index.module.css"
import React, { useState, useContext } from "react"
import { downloadFileStream } from "Common/common"
import { NoticeV2Context } from "../index"
import { methodOptions, dateSuffixIcon } from "../../Notice/Step/options"
import { generateDispositionNoticePdfV2 } from "../api"

const Step4 = () => {
  const { saveDetails, loanId } = useContext(NoticeV2Context)
  const [loading, setLoading] = useState(false)

  const handleDownloadPDF = async () => {
    setLoading(true)
    try {
      await saveDetails()
      const response = await generateDispositionNoticePdfV2(loanId)
      downloadFileStream(response)
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Row className={[styles.step, styles.step2].join(" ")}>
      <Col className={styles.title} span={24} offset={0}>
        Delivery method
      </Col>
      <Col md={18} xs={24}>
        <Form.Item name={["L4", "method"]} label="Method">
          <Checkbox.Group options={methodOptions} size="large" />
        </Form.Item>
      </Col>
      <Col md={6} xs={24}>
        <Form.Item name={["L4", "deliveryDate"]} label="Delivery date">
          <DatePicker size="large" format="MM/DD/YYYY" suffixIcon={dateSuffixIcon} />
        </Form.Item>
      </Col>
      <Col md={24} xs={24}>
        <Button onClick={handleDownloadPDF} className={styles.pdfBtn} loading={loading}>
          Generate PDF
        </Button>
      </Col>
    </Row>
  )
}

export default Step4
